export const sortByClinicalSignificance = (clinicalSignificances) => {
  if (!clinicalSignificances) return [];
  const significancesSet = clinicalSignificances
    .map((x) => x.toLowerCase())
    .reduce((a, i) => a.add(i), new Set());

  return Array.from(
    [
      "Disease",
      "Pathogenic",
      "Likely Pathogenic",
      "Uncertain Significance",
      "Likely Benign",
      "Benign",
      "Polymorphism",
    ]
      .filter((x) => significancesSet.has(x.toLowerCase()))
      .map((x) => (x === "Disease" ? "Pathogenic" : x)) // 'Disease' is a synonym for 'Pathogenic'
      .map((x) => (x === "Likely Pathogenic" ? "Pathogenic" : x)) // 'Likely Pathogenic' is a synonym for 'Pathogenic'
      .map((x) => (x === "Likely Benign" ? "Benign" : x)) // 'Likely Benign' is a synonym for 'Benign'
      .map((x) => (x === "Polymorphism" ? "Benign" : x)) // 'Polymorphism' is a synonym for 'Benign'
      .reduce((a, i) => a.add(i), new Set())
      .values()
  );
};
